import React from 'react';
import * as R from 'ramda';
import { graphql } from 'react-apollo';
import { GET_USER_INFO } from '../apollo/graphql/user';
import { ADMIN, ANONYMOUS } from '../constants/rule';
import { Redirect } from '@reach/router';

const isAuth = validRoles => R.either(R.equals(R.__, ADMIN), R.contains(R.__, validRoles));

const PrivateRoute = ({ children, userInfo, roles = [] }) => {
  const loading = R.propOr(true, 'loading', userInfo);

  // TODO: 取得 user 資訊時的載入畫面
  if (loading) return null;

  const role = R.pathOr(ANONYMOUS, ['user', 'role'], userInfo);

  return isAuth(roles)(role) ? children : <Redirect to="/public" />;
};

export default graphql(GET_USER_INFO, { name: 'userInfo' })(PrivateRoute);
